export default __webpack_public_path__ + "static/media/Icon-rotate-alt-right.de6aaeb1.svg";